import { Component, Inject,ViewChild } from '@angular/core';
import { ApiService } from 'app/api.service';
import { MAT_DIALOG_DATA,MatDialog,MatDialogRef } from '@angular/material/dialog';
import { ApprovalTimelineDialogComponent } from '../../../components/approval-timeline/approval-timeline-dialog.component';
import { ApprovalTimelineData } from '../../../components/approval-timeline/approval-timeline.component';
import { GrnFileModalComponent } from '../grn-file-modal/grn-file-modal.component';
import { DocumentTracingModalComponent } from 'app/components/document-tracing-modal/document-tracing-modal.component';
import { MatSelect } from '@angular/material/select';
import { ReOpenService } from 'app/reopen.service';
import { CancelApprovalService } from 'app/cancel-approval.service';
import { UiPanelAction, UiPanelMode, UiApprovalStep } from 'app/shared/ui/models/ui-document-panel.model';
import { UiBadgeVariant } from 'app/shared/ui/models/ui-badge.model';
import { UiUnsavedChangesDialogComponent, UnsavedChangesResult } from 'app/shared/ui/document-panel/ui-unsaved-changes-dialog/ui-unsaved-changes-dialog.component';
import { UI_DOCUMENT_PANEL_BREADCRUMBS } from 'app/shared/ui/document-panel/document-panel.config';

@Component({
  selector: 'app-grn-dialog',
  templateUrl: './grn-dialog.component.html',
  styleUrls: ['./grn-dialog.component.scss'],
  host: { class: 'ui-document-panel-host' },
})
export class GrnDialogComponent {
  po: any;
  po_data: any[] = [];
  grn_no: any;
  date: any;
  maxDate: string = '';
  productList: any[] = [];
  document_no: number = null;
  vendor: any;
  vendordata: any;
  vendorid: any;
  filteredQuotations = [];
  isUpdateMode: boolean = false;
  isView: boolean = false;
  panelMode: UiPanelMode = 'create';
  enteredEditFromView = false;
  editSnapshot: string | null = null;
  user_id: any;
  readonly breadcrumb = UI_DOCUMENT_PANEL_BREADCRUMBS.grn;
  selectedBranchName: string = '';
  selectedBranchId:any;
  branch:any;
  selectedBranch:any;
  vendordetails:any;
  section_data:any[];
  section: any[] = [];
  fullhostname: string;
  hostname: string;
  image_data: any;
  type: any;
  uploadedFiles: any[] = [];
  remark:any;
  profitCostData: any[] = [];
 sectionData: any[] = [];
//  profitcost: number | null = null;
 profitcost: any[] = [];
  allSections: any[];
 invoice_date: any;
 invoice_receive_date: any;
  poSections: any;
  is_reverse: boolean = false;
  previousPo: any[] = [];
  initialPo: any[] = [];
  previousProfitCost: any;
  previousSection: any;
  vendorOffset = 0;
  vendorLimit = 100;
  vendorHasMore = true;
  loadingVendor = false;
  vendorSearch = '';
  po_no:any;
  profitCostOffset = 0;
  profitCostLimit = 100;
  profitCostHasMore = true;
  profitCostSearch = '';
  loadingProfitCost = false;
  @ViewChild('profitCostSelect') profitCostSelect!: MatSelect;
  // po_ids: string = '';
  // po_id: any[] = [];
  branch_id: any;
  branch_data: any[] = [];
  branch_pc_data: any[] = [];
  filteredBranchData: any[] = [];
  filteredProfitCostData: any[] = [];
  filteredSectionData: any[] = [];
  @ViewChild('vendorSelect') vendorSelect!: MatSelect;
  constructor(
    private apiService: ApiService,
    public dialogRef: MatDialogRef<GrnDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private reopenService: ReOpenService,
    private cancelApprovalService: CancelApprovalService,
  ) {
    const userString = localStorage.getItem('data');
    const user = JSON.parse(userString) || {};
    this.user_id = user?.id;
    this.type = this.data?.type|| 'create';
     if (this.data?.type === 'reverse') {
        this.is_reverse = true;
      } else {
        this.is_reverse = false;
      }
      this.initPanelMode();
  }
  ngOnInit(): void {
    const today = new Date();
    this.date = this.formatDate(today);
    this.maxDate = this.formatDate(today);
    this.fetchGrnProductList(this.data?.id);
    this.vendorData();
    // this.fetchSection();
    this.hostname = window.location.hostname;
    this.fullhostname = window.location.origin;
    if (this.panelMode === 'edit') {
      this.editSnapshot = this.captureEditSnapshot();
    }
  }
   formatDate(date: Date): string {
    return date.toISOString().split('T')[0];
  }
  fetchGrnProductList(GrnId): void {
    this.apiService.showGrnById(GrnId).subscribe(
      (response) => {
        
        this.productList = response.data;
        console.log('update responce',this.productList)
        this.date = this.productList[0].date,
        this.invoice_date = this.productList[0].invoice_date,
        this.invoice_receive_date = this.productList[0].invoice_receive_date,
          this.grn_no = this.productList[0].grn_no,
          this.document_no = this.productList[0].doc_no,
          this.vendor = this.productList[0].vendor.id,
          this.getBranch(this.vendor);
          this.selectedBranchName = this.productList[0].vendor_branch.branch_name,
          this.selectedBranchId = this.productList[0].vendor_branch_id??'';
          this.vendorDetails(this.selectedBranchId);
          this.branch = this.productList[0]?.vendor_branch_id;
          this.branch_id = this.productList[0]?.branch_id;
          this.po_ids=this.productList[0].purchase_order_id,
          this.po=this.productList[0].purchase_order_id.split(',').map(Number);
          this.previousPo = [...this.po];
          this.initialPo = [...this.po];
           console.log('update po',this.po);
          console.log('po_ids',this.po_ids)
          console.log('date:', this.date);
          this.fetchpo(this.vendor,this.selectedBranchId)
          //this.fetchProductList();
          // this.fetchProfitSection(this.po); 
          this.onPoChange(this.po);
          // this.profitcost= this.productList[0].profit_cost_id;
          this.profitcost = this.productList[0].profit_cost_id 
            ? String(this.productList[0].profit_cost_id).split(',').map(Number) 
            : [];
          this.previousProfitCost = this.profitcost;
          console.log('profit cost data',this.profitcost);
          this.section = this.productList[0].section_id
          ? String(this.productList[0].section_id)
            .split(',')
            .map(Number)
          : [];
          this.previousSection = [...this.section];
          //this.filterSectionsByProfitCost(this.profitcost);
          // this.section= this.productList[0].section_id;
             this.remark=this.productList[0].remark
        if (response.uploaded_files && response.uploaded_files.length > 0) {
          this.uploadedFiles = response.uploaded_files.map((file: any) => ({
            ...file,
            preview: `${this.fullhostname}/api/storage/${file.image}`,
          }));
        } else {
          this.uploadedFiles = [];
        }         
      },
      (error) => {
        console.error('Error fetching gsrn products:', error);
        this.productList = [];
      }
    );
  }
  // fetchpo(vendor_id: any) {
  //   this.productList = [];
  //   this.vendorid = vendor_id;
  //   console.log('vendor id ', this.vendorid)
  //   const postData = {
  //     vendor_id: this.vendorid
  //   };
  //   this.apiService.getPurchase(postData).subscribe(
  //     (response) => {
  //       this.po_data = response;
  //       console.log('po ', this.po_data)
  //     },
  //     (error) => {
  //       console.error('Error fetching data:', error);
  //     }
  //   );
  // }
  po_ids: string = '';
  fetchpo(vendor_id: any, branch_id: any, search: string = '') {
    if (!vendor_id || !branch_id) {
      this.po_data = [];
      return;
    }

    const branchChanged = branch_id !== this.selectedBranchId;
    this.vendorDetails(branch_id);
    this.vendorid = vendor_id;
    this.selectedBranchId = branch_id;

    const selectedBranch = this.selectedBranch?.find((b: any) => b.id === branch_id);
    if (selectedBranch) {
      this.selectedBranchName = selectedBranch.branch_name;
    }

    if (!this.isUpdateMode && branchChanged && !search) {
      this.po = [];
      this.productList = [];
    }

    const postData: any = {
      vendor_id: this.vendorid,
      branch_id: branch_id
    };
    if (search) {
      postData.search = search;
    }
    this.apiService.getPurchase(postData).subscribe(
      (response) => {
        if (!response || response.length === 0) {
          this.po_data = [];
          return;
        }
        this.po_data = response.filter(item => item.short_close !== 1);
        if (this.data?.id) {
          this.setSelectedpo(this.po_ids);
        }
      },
      (error) => {
        console.error('Error fetching data:', error);
        this.po_data = [];
      }
    );
  }

  po_id: any[] = [];
  setSelectedpo(poIds: string) {
    console.log('so_ids', poIds);
    this.po = poIds.split(',').map(id => +id);
    console.log('so', this.po);
  }
  getTotalReceiveQty(details: any[], levelNo: any, po_id: number): number {
    if (!details) return 0;
    return details
      .filter((d) => d.level_no === levelNo && d?.grn?.purchase_order_id == po_id)
      .reduce((sum, d) => sum + parseFloat(d.receive_qty), 0);
  }

  // getRemainingQty(detail: any): number {
  //   const remainingQty = detail?.qty - this.getTotalReceiveQty(detail?.grn_details, detail?.level_no, detail?.purchase_order_id);
  //   return parseFloat(remainingQty.toFixed(2));
  // }
  vendorData(
  params?: {
    offset?: number;
    limit?: number;
    search?: string;
  }
){
  if (this.loadingVendor || !this.vendorHasMore) return;
  this.loadingVendor = true;
  if (params && params.offset !== undefined && params.limit !== undefined) {
    this.apiService.vendorOfPo({
      offset: params.offset,
      limit: params.limit,
      search: params.search,
      type: 'lazyloading'
    }).subscribe(
      (response: any[]) => {
        const data = response || [];

        this.vendordata = [
          ...this.vendordata,
          ...data
        ];

        if (data.length < this.vendorLimit) {
          this.vendorHasMore = false;
        }

        this.vendorOffset += data.length;
        this.loadingVendor = false;
      },
      () => (this.loadingVendor = false)
    );
    return;
  }
  this.apiService.vendorOfPo().subscribe(
    (response: any[]) => {
      this.vendordata = response || [];
      this.loadingVendor = false;
    },
    () => (this.loadingVendor = false)
  );
}

  fetchgrnNo() {
    // this.apiService.getGrnNo().subscribe(
    //   (response) => {
    //     this.grn_no = response.grn_no;
    //     console.log('grn_no :', this.grn_no);
    //   },
    //   (error) => {
    //     console.error('Error fetching data:', error);
    //   }
    // );
  }
  // onSearchClick(): void {
  //   this.fetchProductList();
  //   this.fetchgrnNo();
  // }
//  fetchProductList(po: any, section: any,profitcost:any): void {
//     const payload = {
//       po_id: po,
//       section_id: section,
//       profit_cost_id:profitcost
//     };
//     this.apiService.getProductsByPo(payload).subscribe(
//       (response) => {
//         this.productList = response.data;
//         console.log('Fetched Po Product List:', this.productList);
//       },
//       (error) => {
//         console.error('Error fetching Po products:', error);
//         this.productList = [];
//       }
//     );
//   }

   fetchProductList(po: any[], section: any[], profitcost: any[]): void {
      const poIds = Array.isArray(po) ? po.map(id => Number(id)) : [];
      const sectionIds = Array.isArray(section) ? section.map(id => Number(id)) : [];
      const profitCostIds = Array.isArray(profitcost) ? profitcost.map(id => Number(id)) : [];
      this.apiService.getProductsByPo(poIds, sectionIds, profitCostIds).subscribe(
        (response) => {
          this.productList = response.data;
          console.log('Fetched Po Product List:', this.productList);
        },
        (error) => {
          console.error('Error fetching Po products:', error);
          this.productList = [];
        }
      );
    }

  
  onFileSelected(event: any): void {
  const files: FileList = event.target.files;

  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    const reader = new FileReader();

    reader.onload = (e: any) => {
        console.log('Reader result:', e.target.result); 
      this.uploadedFiles.push({
        file: file,
        name: file.name,
        preview: e.target.result
      });
    };

    reader.readAsDataURL(file);
  }
}

  getTitle(): string {
    return this.panelTitle;
  }

  get isInputDisabled(): boolean {
    return this.panelMode === 'view' || this.is_reverse;
  }

  private initPanelMode(): void {
    if (this.data?.type === 'View') {
      this.panelMode = 'view';
      this.isView = true;
      this.isUpdateMode = true;
    } else if (this.data?.type === 'Update' || this.data?.type === 'reverse') {
      this.panelMode = 'edit';
      this.isView = false;
      this.isUpdateMode = true;
    } else {
      this.panelMode = 'create';
      this.isView = false;
      this.isUpdateMode = false;
    }
  }

  get panelTitle(): string {
    if (this.is_reverse) return 'Reverse GSRN';
    switch (this.panelMode) {
      case 'create': return 'Create GSRN';
      case 'edit': return 'Edit GSRN';
      case 'view': return 'View GSRN';
      default: return 'GSRN';
    }
  }

  get statusLabel(): string {
    if (!this.data?.id) return 'Draft';
    return this.data.approval_status || 'Open';
  }

  get statusVariant(): UiBadgeVariant {
    const status = this.data?.approval_status;
    if (!this.data?.id || status == null || status === 'Open') return 'default';
    if (status === 'Approved') return 'approved';
    if (status === 'Pending') return 'pending';
    if (status === 'Rejected') return 'rejected';
    return 'default';
  }

  get approvalSteps(): UiApprovalStep[] {
    const status = this.data?.approval_status;
    const steps: UiApprovalStep[] = [
      { id: 'draft', label: 'Draft', icon: 'edit_note', state: 'upcoming' },
      { id: 'pending', label: 'Pending Approval', icon: 'schedule', state: 'upcoming' },
      { id: 'approved', label: 'Approved', icon: 'check_circle', state: 'upcoming' },
    ];
    if (!this.data?.id) { steps[0].state = 'active'; return steps; }
    if (status == null || status === 'Open') steps[0].state = 'active';
    else if (status === 'Pending') { steps[0].state = 'completed'; steps[1].state = 'active'; }
    else if (status === 'Approved') { steps[0].state = 'completed'; steps[1].state = 'completed'; steps[2].state = 'completed'; }
    else if (status === 'Rejected') { steps[0].state = 'completed'; steps[1].state = 'rejected'; }
    return steps;
  }

  canEdit(): boolean {
    if (this.is_reverse) return false;
    const status = this.data?.approval_status;
    return status == null || status === 'Open' || status === 'Rejected';
  }

  enterEditMode(): void {
    if (!this.canEdit()) return;
    this.enteredEditFromView = true;
    this.panelMode = 'edit';
    this.isView = false;
    this.isUpdateMode = true;
    if (this.data) this.data.type = 'Update';
    this.editSnapshot = this.captureEditSnapshot();
  }

  enterViewMode(): void {
    this.panelMode = 'view';
    this.isView = true;
    this.isUpdateMode = true;
    this.enteredEditFromView = false;
    this.editSnapshot = null;
    if (this.data) this.data.type = 'View';
  }

  private captureEditSnapshot(): string {
    return JSON.stringify({
      po: this.po, date: this.date, vendor: this.vendor, branch: this.branch,
      branch_id: this.branch_id, profitcost: this.profitcost, section: this.section,
      document_no: this.document_no, remark: this.remark, invoice_date: this.invoice_date,
      invoice_receive_date: this.invoice_receive_date, productList: this.productList,
    });
  }

  hasUnsavedChanges(): boolean {
    if (this.panelMode !== 'edit' || !this.editSnapshot) return false;
    return this.captureEditSnapshot() !== this.editSnapshot;
  }

  private restoreFromSnapshot(): void {
    if (!this.editSnapshot) return;
    const s = JSON.parse(this.editSnapshot);
    Object.assign(this, {
      po: s.po, date: s.date, vendor: s.vendor, branch: s.branch,
      branch_id: s.branch_id, profitcost: s.profitcost, section: s.section,
      document_no: s.document_no, remark: s.remark, invoice_date: s.invoice_date,
      invoice_receive_date: s.invoice_receive_date, productList: s.productList,
    });
  }

  onClose(): void { this.handleExitIntent('close'); }
  onCancel(): void {
    if (this.panelMode === 'edit' && this.enteredEditFromView) {
      this.handleExitIntent('view');
      return;
    }
    this.handleExitIntent('close');
  }

  private handleExitIntent(intent: 'close' | 'view'): void {
    if (this.panelMode === 'edit' && this.hasUnsavedChanges()) {
      this.promptUnsavedChanges(intent);
      return;
    }
    this.executeExitIntent(intent);
  }

  private executeExitIntent(intent: 'close' | 'view'): void {
    if (intent === 'view') this.enterViewMode();
    else this.dialogRef.close();
  }

  private promptUnsavedChanges(intent: 'close' | 'view'): void {
    const promptRef = this.dialog.open(UiUnsavedChangesDialogComponent, {
      width: '440px', disableClose: true, panelClass: 'ui-unsaved-changes-dialog',
    });
    promptRef.afterClosed().subscribe((result: UnsavedChangesResult | undefined) => {
      if (!result || result === 'cancel') return;
      if (result === 'discard') { this.restoreFromSnapshot(); this.executeExitIntent(intent); return; }
      if (result === 'save') this.save(intent);
    });
  }

  get footerPrimaryActions(): UiPanelAction[] {
    if (this.panelMode === 'view') {
      return this.canEdit() ? [{ id: 'edit', label: 'Edit', icon: 'edit', variant: 'primary', visible: true }] : [];
    }
    return [
      { id: 'save', label: 'Save', icon: 'save', variant: 'success', visible: true },
      { id: 'send-approval', label: 'Send for Approval', icon: 'send', variant: 'primary',
        visible: !!this.data?.id && this.canEdit() && !this.is_reverse },
    ];
  }

  get footerSecondaryActions(): UiPanelAction[] {
    return [
      { id: 'tracing', label: 'Document Tracing', icon: 'account_tree', variant: 'outline',
        visible: !!this.data?.id && this.panelMode !== 'view' },
      { id: 'timeline', label: 'Approval Timeline', icon: 'timeline', variant: 'outline',
        visible: !!this.data?.id && ['Pending','Rejected','Approved'].includes(this.data.approval_status) && this.panelMode !== 'view' },
      { id: 'cancel', label: this.panelMode === 'view' ? 'Close' : 'Cancel', icon: 'close', variant: 'ghost', visible: true },
    ];
  }

  get footerDestructiveAction(): UiPanelAction | null {
    if (this.panelMode !== 'view' || this.user_id !== 1 || !this.data?.id) return null;
    return { id: 'delete', label: 'Delete', icon: 'delete', variant: 'danger', visible: true };
  }

  get footerOverflowActions(): UiPanelAction[] {
    if (this.panelMode !== 'view' || !this.data?.id) return [];
    const status = this.data.approval_status;
    return [
      { id: 'tracing', label: 'Document Tracing', icon: 'account_tree', visible: true },
      { id: 'timeline', label: 'Approval Timeline', icon: 'timeline',
        visible: ['Pending','Rejected','Approved'].includes(status) },
      { id: 'reopen', label: 'Reopen', icon: 'replay', visible: status === 'Approved' && this.user_id === 1 },
      { id: 'cancel-approval', label: 'Cancel Approval', icon: 'cancel', visible: status === 'Pending' && this.user_id === 1 },
      { id: 'reverse', label: 'Reverse', icon: 'undo', visible: status === 'Approved' && !this.is_reverse },
    ];
  }

  onFooterAction(actionId: string): void {
    switch (actionId) {
      case 'save': this.save(); break;
      case 'send-approval': this.sendForApprove(); break;
      case 'tracing': if (this.data?.id) this.viewRelatedDocuments(this.data.id); break;
      case 'timeline': this.showApprovalTimeline(); break;
      case 'edit': this.enterEditMode(); break;
      case 'delete': this.deleteGrn(); break;
      case 'reopen': this.onReopen(); break;
      case 'cancel-approval': this.onCancelApproval(); break;
      case 'reverse': this.openReverseMode(); break;
      case 'cancel': this.onCancel(); break;
    }
  }

  deleteGrn(): void {
    if (!this.data?.id) return;
    this.apiService.deleteGrn(this.data.id).subscribe(
      (response) => { alert(response.message); this.dialogRef.close({ id: this.data.id, action: 'delete' }); },
      (error) => alert(error.error?.message)
    );
  }

  onReopen(): void {
    if (!this.data?.id) return;
    this.reopenService.reopen(this.data.id, 'Grn', () => {
      this.data.approval_status = 'Open';
      this.enterViewMode();
    });
  }

  onCancelApproval(): void {
    if (!this.data?.id) return;
    this.cancelApprovalService.cancelApproval(this.data.id, 'Grn', () => {
      this.data.approval_status = 'Open';
      this.enterViewMode();
    });
  }

  openReverseMode(): void {
    if (!this.data?.id) return;
    this.is_reverse = true;
    this.panelMode = 'edit';
    this.isView = false;
    this.data.type = 'reverse';
    this.editSnapshot = this.captureEditSnapshot();
  }

  openGrnFileShowModal() {
  if (this.data.id) {
    this.apiService.getGrnFiles(this.data.id).subscribe(
      (response) => {
        this.image_data = response.uploadedFiles;
        console.log('GSRN file data:', this.image_data);

        this.dialog.open(GrnFileModalComponent, { 
          width: '1200px',
          height: '600px',
          data: {
            id: this.data.id,
            images: this.image_data
          }
        });
      },
      (error) => {
        console.error("Error fetching GSRN files:", error);
      }
    );
  } else {
    console.error("Invalid GSRN ID.");
  }
}

isImage(file: any): boolean {
  const filePath = file?.image || file?.name || '';
  return typeof filePath === 'string' && (
    filePath.toLowerCase().endsWith('.png') ||
    filePath.toLowerCase().endsWith('.jpg') ||
    filePath.toLowerCase().endsWith('.jpeg')
  );
}

isPDF(file: any): boolean {
  const filePath = file?.image || file?.name || '';
  return typeof filePath === 'string' && filePath.toLowerCase().endsWith('.pdf');
}

isPreviewable(extension: string): boolean {
  return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'pdf'].includes(extension);
}

removeFile(index: number): void {
  this.uploadedFiles.splice(index, 1);
}


  save(exitAfterSave: 'close' | 'view' = 'view'): void {
    if (!this.vendor || !this.branch || !this.po || !this.profitcost || !this.document_no || !this.date || !this.invoice_date || !this.invoice_receive_date) {
      alert('Please fill in all required fields.');
      return;
    }
    if (!this.data?.id) {
      // create case
      for (const product of this.productList) {
        const hasRemainingQty = product.po_details.some(detail => (detail.remaining_qty || 0) > 0);
        if (!hasRemainingQty) {
          alert('No line items found');
          return;
        }
        for (const detail of product.po_details) {
          const pendingQty = detail.remaining_qty || 0;
          if (detail.receive_qty > pendingQty) {
            alert(
              `Receive Quantity (${detail.receive_qty}) cannot be greater than Pending Quantity (${pendingQty}) for ${detail.item_service_type === 'SKU'
                ? detail?.stock_keeping?.sku_name
                : detail?.service?.service_name
              }`
            );
            return;
          }
        }
      }
    } else {
      // Update case
      for (const product of this.productList) {
        for (const detail of product.details) {
          const pendingQty = this.getInitialTotal(detail);
          if (detail.receive_qty > pendingQty) {
            alert(
              `Receive Quantity (${detail.receive_qty}) cannot be greater than Pending Quantity (${pendingQty}) for ${detail.item_service_type === 'SKU'
                ? detail?.sku?.sku_name
                : detail?.service?.service_name
              }`
            );
            return;
          }
        }
      }
    }

    const postData = {
      po_id: this.po,
      grn_no: this.grn_no || null,
      date: this.date,
      doc_no: this.document_no,
      vendor_id: this.vendor,
      vendor_branch: this.branch,
      branch_id: this.branch_id,
      profit_cost_id:this.profitcost,
      section_id: this.section,
      uploaded_files: this.uploadedFiles,
       document_type: 'Gsrn',
      remark:this.remark,
      invoice_date:this.invoice_date,
      invoice_receive_date:this.invoice_receive_date,
      type:this.data?.type,
      products: this.productList.map(product => {
        const poDetails = Array.isArray(product.po_details)
          ? product.po_details
              .filter(detail => detail.remaining_qty > 0)
              .map(detail => ({
                sku_id: detail.item_service_type === 'SKU'
                  ? detail.stock_keeping?.id
                  : detail.item_service_type === 'Service'
                    ? detail.service?.id
                    : detail.item_service_type === 'Fixed Asset'
                      ? detail.fa_template?.id
                      : null,
                specification: detail.specification || '',
                description: detail.description || '',
                quantity: detail.qty || 0,
                hsn_no: detail.hsn_no || '',
                unit_id: detail.unit?.id || null,
                start_date: detail.start_date || null,
                end_date: detail.end_date || null,
                price: detail.price || 0,
                receive_qty: detail.receive_qty ?? 0,
                delivery_date: product.delivery_deadline_date || null,
                unit_price: detail.unit_price || 0.00,
                level_no: detail.level_no,
                item_service_type: detail.item_service_type,
                section_id: detail.section_id,
                // store_id: detail.stock_keeping.store_id ?? '',
                purchase_order_id: detail.purchase_order_id,
                reverse_qty: detail.reverse_qty,
                grn_id:detail.grn_id,
                profit_cost_id:detail.profit_cost_id,
              }))
          : [];
    
        const productDetails = Array.isArray(product.details)
          ? product.details.map(detail => ({
              sku_id: detail.item_service_type === 'SKU'
                  ? detail.sku?.id
                  : detail.item_service_type === 'Service'
                    ? detail.service?.id
                    : detail.item_service_type === 'Fixed Asset'
                      ? detail.fa_template?.id
                      : null,
              specification: detail.specification || '',
              description: detail.description || '',
              quantity: detail.qty || 0,
              hsn_no: detail.hsn_no || '',
              unit_id: detail.unit?.id || null,
              start_date: detail.start_date || null,
              end_date: detail.end_date || null,
              price: detail.price || 0,
              receive_qty: detail.receive_qty ?? 0,
              delivery_date: product.delivery_deadline_date || null,
              unit_price: detail.unit_price || 0.00,
              item_service_type: detail.item_service_type,
              level_no: detail.level_no,
              section_id: detail.section_id,
              purchase_order_id: detail.purchase_order_id,
              // store_id: detail.stock_keeping.store_id,
              reverse_qty: detail.reverse_qty,
              grn_id: detail.grn_id,
              profit_cost_id:detail.profit_cost_id,
            }))
          : [];
    
        const combinedDetails = [...poDetails,...productDetails].filter(
          detail => Object.keys(detail).length > 0
        );
    
        return { details: combinedDetails };
      }),
    };

      
    

    console.log('Post Data:', postData);
    // return;
    if (this.data?.id) {
      this.apiService.updateGrn(this.data.id, postData).subscribe(
        (response: any) => {
          if (response?.status === true) {
            alert(response?.message);
            if (exitAfterSave === 'close') {
              this.dialogRef.close({ id: this.data.id, action: 'update' });
            } else {
              this.enterViewMode();
            }
          } else {
            alert(response?.message || 'Something went wrong!');
          }
        },
        error => {
          console.error('Error updating GSRN:', error);
        }
      );
    } else {
      this.apiService.createGrn(postData).subscribe(
       (response: any) => {
          if (response?.status === true) {
            alert(response?.message);
             this.dialogRef.close({ id: response.data.id, action: 'create' });
          } else {
            alert(response?.message || 'Something went wrong!');
          }
        },
        error => {
          console.error('Error creating GSRN:', error);
        }
      );
    }
  }

  
  getBranch(VendorId: number []) {
    this.apiService.getbranch(VendorId).subscribe(
      (response) => {
        this.selectedBranch = response.data;
        console.log(this.selectedBranch);
      },
      (error) => {
        console.error("Error fetching branch data:", error);
      }
    );
  }
  allowOnlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.key;
    if ((charCode >= '0' && charCode <= '9') || charCode === '.') {
      return true;
    }
    event.preventDefault();
    return false;
  }

    vendorDetails(id: number){
      this.apiService.vendorbranchdetails(id).subscribe(
        (response) => {
          this.vendordetails = response;
          console.log('vendordetails', this.vendordetails);
        },
        (error) => {
          console.error('Error fetching data:', error);
        }
      );
    }
    
  onPoChange(po_ids: number[]): void {
    const data = { purchase_order_id: po_ids };
    this.apiService.getBranchByPo(data).subscribe(
      (response: any[]) => {
        this.branch_pc_data = response;
        console.log('branch_pc_data:', this.branch_pc_data);

        this.fetchbranch();
        if (this.data?.id) {
          this.fetchAllProfitCenters();
          this.fetchAllSections();
        }
        if (!this.isUpdateMode) {
          this.branch_id = null;
          this.profitcost = [];
          this.section = [];
          this.productList = [];
        }
        this.po = po_ids;
        this.fetchProfitSection(po_ids);
      },
      (error) => {
        this.branch_pc_data = [];
        this.filteredBranchData = [];
        console.error('Error fetching Purchase Order related data:', error);
      }
    );
  }

    fetchbranch(): void {
      this.apiService.getDatabranch().subscribe(
        (response) => {
          this.branch_data = response;
          console.log('branch fetched:', this.branch_data);
          this.filterBranchData();
        },
        (error) => {
          console.error('Error fetching branches:', error);
        }
      );
    }

    fetchAllProfitCenters(): void {
      this.apiService.getProfitCostCenter().subscribe(
        (response) => {
          this.profitCostData = response.data || response || [];
          console.log('Profit Centers fetched:', this.profitCostData);
          this.filterProfitCostData();
        },
        (error) => {
          console.error('Error fetching profit centers:', error);
        }
      );
    }

    fetchAllSections(): void {
      this.apiService.getSection().subscribe(
        (response) => {
          this.section_data = response.data || response || [];
          console.log('Sections fetched:', this.section_data);
          this.filterSectionData();
        },
        (error) => {
          console.error('Error fetching sections:', error);
        }
      );
    }

    filterBranchData(): void {
      if (this.branch_pc_data?.length > 0) {
        const branchIds = [...new Set(this.branch_pc_data.map(item => item.branch_id))];
        this.filteredBranchData = this.branch_data.filter(branch => branchIds.includes(branch.id));
        console.log('Filtered Branches:', this.filteredBranchData);
      } else {
        this.filteredBranchData = [];
        console.log('No branch_pc_data found, clearing branches');
      }
    }

    onBranchChange(): void {
      this.fetchAllProfitCenters();
      this.filterProfitCostData();
      this.filterSectionData();
      if (!this.data?.id) {
        this.profitcost = [];
        this.section = [];
        this.productList = [];
      }
    }

    filterProfitCostData(): void {
      if (this.branch_pc_data?.length > 0) {
        const profitCostIds = [
          ...new Set(
            this.branch_pc_data
              .filter(item => !this.branch_id || item.branch_id === this.branch_id)
              .flatMap(item => (item.profit_cost_id || []).map((id: string) => Number(id)))
          ),
        ];
        this.filteredProfitCostData = this.profitCostData.filter(pc => profitCostIds.includes(Number(pc.id)));
        console.log('Filtered PC/CC Data:', this.filteredProfitCostData);
      } else {
        this.filteredProfitCostData = [];
      }
    }

    filterSectionData(): void {
      if (this.branch_pc_data?.length > 0) {
        const sectionIds = [
          ...new Set(
            this.branch_pc_data
              .filter(item => !this.branch_id || item.branch_id === this.branch_id)
              .flatMap(item => (item.section_id || []).map((id: string) => Number(id)))
          ),
        ];
        
        let filtered = this.section_data.filter(section => sectionIds.includes(section.id));

        if (this.profitcost && this.profitcost.length > 0) {
          filtered = filtered.filter(section => this.profitcost.includes(Number(section.profit_cost_id)));
        }

        this.filteredSectionData = filtered;
        console.log('Filtered Sections:', this.filteredSectionData);
      } else {
        this.filteredSectionData = [];
      }
    }

    getBranchName(branchId: number | null): string {
      if (!branchId) return 'No branch selected';
      const branch = this.filteredBranchData?.find(b => b.id === branchId);
      return branch ? branch.name : 'Unknown branch';
    }
    //  fetchSection() {
    //    this.apiService.getSection().subscribe(
    //     (response) => {
    //       this.section_data = response;
    //       console.log('Section data by pc/cc:', this.section_data);
    //     },
    //     (error) => {
    //       console.error('Error fetching data:', error);
    //     }
    //   );
    // }

// fetchProfitSection(poIds: any[]) {
//   if (!poIds || poIds.length === 0) {
//     this.profitcost = null;
//     this.section = null;
//     //  this.profitCostData = [];
//     // this.section_data = [];
//     return;
//   }

//   const postData = { po_id: poIds };
//   this.apiService.getProfitSectionByPo(postData).subscribe(
//     (response) => {
//       this.profitCostData = response.profit_cost_centers || [];
//       this.poSections = response.sections || [];
//       console.log('ProfitCost:', this.profitCostData, 'Sections:', this.section_data);
//       if (this.profitcost) {
//         this.filterSectionsByProfitCost(this.profitcost);
//       }  
//     },
//     (error) => {
//       console.error('Error fetching profit cost and sections:', error);
//     }
//   );
// }
  fetchProfitSection(poIds: any[]) {
    if (!this.previousPo) this.previousPo = [];
    if (!this.initialPo) this.initialPo = [];
    const removedInitial = this.initialPo.filter(id => !poIds.includes(id));
    if (this.isUpdateMode && removedInitial.length > 0) {
      const skuIds = this.productList
        .flatMap(p => p.details || [])
        .map(d => d.sku_id)
        .filter(Boolean);

        const postData = {
          doc_id: this.data.id,
          model: 'Grn',
          sku_id: skuIds.length > 0 ? skuIds : undefined
        };
        if (this.data.approval_status == 'Open') {
          this.apiService.checkNextDocument(postData).subscribe((res: any) => {
            if (res.status === false) {
              alert('Cannot change this purchase order because next document is created.');
              setTimeout(() => { this.po = [...this.previousPo]; }); // Revert
              return;
            }
            if (confirm('Changing Purchase Order will clear selected profit cost, section and product details. Do you want to continue?')) {
              this.profitcost = [];
              this.section = [];
              this.productList = [];
              this.performFetchProfitSection(poIds);
            } else {
              setTimeout(() => { this.po = [...this.previousPo]; }); // Revert
            }
          });
        }
        else {
          if (confirm('Changing Purchase Order will clear selected profit cost, section and product details. Do you want to continue?')) {
            this.profitcost = [];
            this.section = [];
            this.productList = [];
            this.performFetchProfitSection(poIds);
          } else {
            setTimeout(() => { this.po = [...this.previousPo]; }); // Revert
          }
        }
        return;
      }
      this.performFetchProfitSection(poIds, true);
    }

    private resetProfitCostFetchState(clearData: boolean = false): void {
      this.profitCostOffset = 0;
      this.profitCostHasMore = true;
      this.loadingProfitCost = false;
      if (clearData) {
        this.profitCostData = [];
      }
    }

    get displayProfitCostData(): any[] {
      if (this.profitCostData?.length) {
        return this.profitCostData;
      }
      return this.filteredProfitCostData || [];
    }

    compareProfitCost = (a: any, b: any): boolean => Number(a) === Number(b);

    performFetchProfitSection(poIds: any[], reset: boolean = false) {
      if (!poIds?.length) {
        return;
      }

      if (reset) {
        this.resetProfitCostFetchState();
      }

      if (this.loadingProfitCost || !this.profitCostHasMore) {
        return;
      }
     this.loadingProfitCost = true;
     this.previousPo = [...poIds];
 
     const postData = {
       po_id: poIds,
       offset: this.profitCostOffset,
       limit: this.profitCostLimit,
       search: this.profitCostSearch || undefined,
     };
     this.apiService.getProfitSectionByPo(postData).subscribe(
       (response) => {
         const data = response.profit_cost_centers || [];
         if (this.profitCostOffset === 0) {
           this.profitCostData = data;
         } else {
           this.profitCostData = [...this.profitCostData, ...data];
         }
         this.profitCostOffset += data.length;
         this.profitCostHasMore = data.length >= this.profitCostLimit;
         this.poSections = response.sections || [];
         console.log('ProfitCost:', this.profitCostData, 'Sections:', this.section_data);
         if (this.profitcost) {
           this.filterSectionsByProfitCost(this.profitcost);
         }
         this.loadingProfitCost = false;
       },
       (error) => {
         console.error('Error fetching profit cost and sections:', error);
         this.loadingProfitCost = false;
       }
     );
   }

  filterSectionsByProfitCost(profitCostId: number[]) {
    this.filterSectionData();
    if (this.data?.id && this.productList?.length > 0) {
      console.log('update section', this.data.id);

      this.section = this.productList[0].section_id
        ? String(this.productList[0].section_id)
          .split(',')
          .map(Number)
        : [];
      this.previousSection = [...this.section];
    }
    // this.section = null;
  }

    onProfitCostChange(newVal: any) {
      if (!this.isUpdateMode || this.previousProfitCost == newVal) {
        this.previousProfitCost = newVal;
        this.fetchAllSections();
        return;
      }
      const skuIds = this.productList
        .flatMap(p => p.details || [])
        .map(d => d.sku_id)
        .filter(Boolean);

    const postData = {
      doc_id: this.data.id,
      model: 'Grn',
      sku_id: skuIds.length > 0 ? skuIds : undefined
    };

      const proceed = () => {
        this.previousProfitCost = newVal;
        this.fetchAllSections();
      };

    const revert = () => {
      setTimeout(() => { this.profitcost = this.previousProfitCost; });
    };

    if (this.data.approval_status == 'Open') {
      this.apiService.checkNextDocument(postData).subscribe((res: any) => {
        if (res.status === false) {
          alert('Cannot change profit center because next document is created.');
          revert();
          return;
        }
        if (confirm('Changing profit center will clear current section/product selection. Continue?')) {
          proceed();
        } else {
          revert();
        }
      });
    } else {
      if (confirm('Changing profit center will clear current section/product selection. Continue?')) {
        proceed();
      } else {
        revert();
      }
    }
      if (!this.isUpdateMode) {
        this.productList = [];
      }
  }

  onSectionChange(newVal: any) {
    if (!this.isUpdateMode || this.previousSection == newVal) {
      this.previousSection = newVal;
      this.fetchProductList(this.po, newVal ,this.profitcost);
      return;
    }

    const skuIds = this.productList
      .flatMap(p => p.details || [])
      .map(d => d.sku_id)
      .filter(Boolean);

    const postData = {
      doc_id: this.data.id,
      model: 'Grn',
      sku_id: skuIds.length > 0 ? skuIds : undefined
    };

    const proceed = () => {
      this.previousSection = newVal;
      this.fetchProductList(this.po, newVal ,this.profitcost);
    };

    const revert = () => {
      setTimeout(() => { this.section = this.previousSection; });
    };

    if (this.data.approval_status == 'Open') {
      this.apiService.checkNextDocument(postData).subscribe((res: any) => {
        if (res.status === false) {
          alert('Cannot change section because next document is created.');
          revert();
          return;
        }
        if (confirm('Changing section will clear current product details. Continue?')) {
          proceed();
        } else {
          revert();
        }
      });
    } else {
      if (confirm('Changing section will clear current product details. Continue?')) {
        proceed();
      } else {
        revert();
      }
    }
  }

  sendForApprove() {
    console.log('Send for approval');
    const requestData = {
      document_type: 'Grn',
      document_id: this.data.id,
      profit_cost_id:this.profitcost?.[0],
    };
    this.apiService.sendForApproval(requestData).subscribe(
      (response) => {
        console.log('Send for approval response:', response);
        alert('Document sent for approval');
        this.dialogRef.close({ data: this.data.id, action: 'approvalsend' });
      },
      (error) => {
        console.error('Error sending for approval:', error);
        alert('Error sending for approval' + error.error.message);
      }
    );
  }

  showApprovalTimeline() {
    const requestData = {
      document_type: 'Grn',
      document_id: this.data.id,
    };

    this.apiService.getApprovalTimeline(requestData).subscribe(
      (response) => {
        console.log('Approval timeline data:', response);
        
        // Open approval timeline dialog with real data
        const dialogRef = this.dialog.open(ApprovalTimelineDialogComponent, {
          width: '800px',
          height: '600px',
          disableClose: true,
          data: { approvalData: response.data || response }
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log('Approval timeline dialog closed:', result);
        });
      },
      (error) => {
        console.error('Error fetching approval timeline:', error);
        
        // Fallback to demo data if API fails
        const demoApprovalData: ApprovalTimelineData = {
          document_id: this.data.id || 12345,
          document_type: 'Grn',
          current_stage: 2,
          total_stages: 4,
          overall_status: 'pending',
          created_at: new Date().toISOString(),
          created_by: 'Current User',
          stages: [
            {
              id: 1,
              name: 'Department Head Review',
              level: 1,
              status: 'approved',
              approver_name: 'Sarah Johnson',
              approved_at: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
              comments: 'All requirements met, approved for next level',
              timeline: [],
              pending_time_seconds: 0,
              pending_time_formatted: '0s',
              cancellation_count: 0
            },
            {
              id: 2,
              name: 'Finance Manager Review',
              level: 2,
              status: 'pending',
              is_current: true,
              timeline: [],
              pending_time_seconds: 7200,
              pending_time_formatted: '2h 0m 0s',
              cancellation_count: 0
            },
            {
              id: 3,
              name: 'General Manager Approval',
              level: 3,
              status: 'not_started',
              timeline: [],
              pending_time_seconds: 0,
              pending_time_formatted: '0s',
              cancellation_count: 0
            },
            {
              id: 4,
              name: 'Final Approval',
              level: 4,
              status: 'not_started',
              timeline: [],
              pending_time_seconds: 0,
              pending_time_formatted: '0s',
              cancellation_count: 0
            }
          ]
        };

        const dialogRef = this.dialog.open(ApprovalTimelineDialogComponent, {
          width: '800px',
          height: '600px',
          disableClose: true,
          data: { approvalData: demoApprovalData }
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log('Approval timeline dialog closed:', result);
        });
      }
    );
  }

  viewRelatedDocuments(grnId: number): void {
    const payload = {
      document_id: grnId,
      document_type: "grn"
    };

    // Show loading state
    const loadingDialog = this.dialog.open(DocumentTracingModalComponent, {
      width: '90%',
      maxWidth: '1200px',
      height: '80%',
      maxHeight: '800px',
      disableClose: false,
      data: {
        tracingData: null,
        loading: true
      }
    });

    this.apiService.getDocumentTracing(payload).subscribe(
      (response) => {
        if (response.status) {
          // Close loading dialog and open with data
          loadingDialog.close();

          const dialogRef = this.dialog.open(DocumentTracingModalComponent, {
            width: '90%',
            maxWidth: '1200px',
            height: '80%',
            maxHeight: '800px',
            disableClose: false,
            data: {
              tracingData: {
                ...response.data,
                document_type: "grn",
                current_document: response.data.current_document || `GSRN${grnId}` // Ensure current document is set
              },
              loading: false
            }
          });

          dialogRef.afterClosed().subscribe(() => {
            console.log('Document tracing modal closed');
          });
        } else {
          loadingDialog.close();
          alert('Error: ' + response.message);
        }
      },
      (error) => {
        loadingDialog.close();
        console.error('Error fetching document tracing:', error);

        let errorMessage = 'Error fetching related documents. Please try again.';
        if (error.error && error.error.message) {
          errorMessage = error.error.message;
        } else if (error.message) {
          errorMessage = error.message;
        }

        alert(errorMessage);
      }
    );
  } 
  getInitialTotal(detail: any) {
    if (!detail.initial_total_qty) {
      detail.initial_total_qty = detail.grn_remaining_qty + detail.receive_qty;
    }
    return detail.initial_total_qty;
  }
onReverseQtyChange(detail: any) {

  // Save original only once
  if (detail.original_receive_qty === undefined) {
    detail.original_receive_qty = Number(detail.receive_qty);
  }

  const reverse = Number(detail.reverse_qty) || 0;

  // Calculate new receive
  let newReceive = detail.original_receive_qty - reverse;

  // Stop negative receive
  if (newReceive < 0) {
    alert("Reverse quantity cannot be more than receive quantity!");
    detail.reverse_qty = 0;
    return;
  }
  if (reverse > detail.grn_remaining_qty) {
    alert("Reverse quantity cannot be more than total used quantity!");
    detail.reverse_qty = 0;
    return;
  }

  detail.receive_qty = newReceive;

  console.log("Reverse:", reverse, "Receive Qty:", detail.receive_qty);
}



onVendorOpen(opened: boolean) {
  if (!opened) return;

  this.vendordata = [];
  this.vendorOffset = 0;
  this.vendorHasMore = true;
  this.vendorSearch = '';

  this.vendorData({
    offset: this.vendorOffset,
    limit: this.vendorLimit
  });

  Promise.resolve().then(() => {
    const panel = this.vendorSelect.panel?.nativeElement;
    if (!panel) return;

    panel.removeEventListener('scroll', this.onVendorScroll);
    panel.addEventListener('scroll', this.onVendorScroll);
  });
}
onVendorScroll = (event: any) => {
  const panel = event.target as HTMLElement;

  if (
    panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 20 &&
    this.vendorHasMore &&
    !this.loadingVendor
  ) {
    this.vendorData({
      offset: this.vendorOffset,
      limit: this.vendorLimit,
      search: this.vendorSearch
    });
  }
};
onVendorSearch(value: string) {
  this.vendorSearch = value || '';
  this.vendorOffset = 0;
  this.vendorHasMore = true;
  this.loadingVendor = false; 
  this.vendordata = [];

  this.vendorData({
    offset: this.vendorOffset,
    limit: this.vendorLimit,
    search: this.vendorSearch
  });
}
onVendorChange(event:any) {
  this.branch = null;
  this.po = [];
  this.po_data = [];
  this.selectedBranchId = null;
  this.selectedBranchName = '';
  this.getBranch(this.vendor);
}
getVendorName(vendorId: number | null): string {
  if (!vendorId || !Array.isArray(this.vendordata)) {
    return 'No vendor selected';
  }

  const vendor = this.vendordata.find(v => v.vendor_id === vendorId);
  return vendor ? vendor.vendor_name : 'Unknown Vendor';
}

getVendorBranchName(branchId: number | null): string {
  if (!branchId || !Array.isArray(this.selectedBranch)) {
    return 'No branch selected';
  }

  const branch = this.selectedBranch.find(b => b.id === branchId);
  return branch ? branch.branch_name : 'Unknown Branch';
}

getPurchaseOrder(poIds: number[] | null): string {
  if (!poIds?.length || !Array.isArray(this.po_data)) {
    return 'No PO selected';
  }

  const pos = this.po_data
    .filter(po => poIds.includes(po.id))
    .map(po => po.po_no);

  return pos.length ? pos.join(', ') : 'Unknown PO';
}
getProfitCostName(profitCostId: number | number[] | null): string {
  if (!profitCostId || (Array.isArray(profitCostId) && profitCostId.length === 0)) {
    return 'No Profit/Cost selected';
  }
  const source = this.displayProfitCostData;
  if (!Array.isArray(source) || source.length === 0) {
    return 'No Profit/Cost selected';
  }
  const ids = Array.isArray(profitCostId)? profitCostId: [profitCostId];
  const names = source.filter(pc => ids.includes(Number(pc.id))).map(pc => pc.name);

  return names.length ? names.join(', ') : 'Unknown Profit/Cost Center';
}
getSectionName(sectionId: number | number[] | null): string {
  if (!sectionId || !Array.isArray(this.section_data) || (Array.isArray(sectionId) && sectionId.length === 0)) {
    return 'No Section selected';
  }
  const ids = Array.isArray(sectionId) ? sectionId : [sectionId];
  const names = this.section_data.filter((section) => ids.includes(section.id)).map((section) => section.section_name);

  return names.length ? names.join(", ") : "Unknown Section";
}
onPoOpen(isOpen: boolean) {
  if (isOpen) {
    if (!this.vendor || !this.branch) {
      this.po_data = [];
      return;
    }
    this.po_data = [];
    this.fetchpo(this.vendor, this.branch);
  }
}
onPoSearch(searchText: string) {
  if (!this.vendor || !this.branch) {
    return;
  }
  this.po_data = [];
  this.fetchpo(this.vendor, this.branch, searchText);
}
onProfitCostOpen(opened: boolean) {
  if (!opened || !this.po?.length) {
    return;
  }

  this.profitCostSearch = '';
  if (!this.displayProfitCostData.length) {
    this.performFetchProfitSection(this.po, true);
  }

  Promise.resolve().then(() => {
    const panel = this.profitCostSelect?.panel?.nativeElement;
    if (!panel) return;

    panel.removeEventListener('scroll', this.onProfitCostScroll);
    panel.addEventListener('scroll', this.onProfitCostScroll);
  });
}
onProfitCostSearch(value: string) {
  this.profitCostSearch = value || '';
  this.resetProfitCostFetchState(true);
  this.performFetchProfitSection(this.po, true);
}
onProfitCostScroll = (event: any) => {
  const panel = event.target as HTMLElement;

  if (
    panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 20 &&
    this.profitCostHasMore &&
    !this.loadingProfitCost
  ) {
    this.performFetchProfitSection(this.po);
  }
};
}